import React from "react";
import { useState } from "react";
import About from "./About";
// import TextFormx from "./TextFormx";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  // const [text1, setText] = useState("");
  // const handelsearch = () => {
  //   let w = text1.split(" ");
  //   let w1 = document.getElementById("myBox");
  //   console.log(w1);
  //   if(w===w1)
  //   {
  //     setText("item found");
  //   }
  //   else
  //   setText("null")
    
  // };

  // const handlechange = (event) => {
  //   console.log("on change");
  //   setText(event.target.value);
  // };

  return (
    <div >
      <nav className={`navbar navbar-expand-lg navbar-dark bg-${props.mode}`}>
        <div className="container-fluid">
          <Link className="navbar-brand" to="/"><b>Textconvert</b></Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link"  to="/About">About</Link>
              </li>
            </ul>
            <form className="d-flex">
              {/* <input
                value={text1}
                onChange={handlechange}
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button
                className={`btn btn-${props.mode} mx-2`}
                type="submit"
                onClick={handelsearch}
              >
                <Link>Search</Link>
              </button> */} 
              <button
                className={`btn btn-${props.mode} mx-2`} 
          
              >
                
                <div className="form-check form-switch">
                Dark/Light
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    onClick={props.togglemode}
                    id="flexSwitchCheckDefault"
                  />
                  
                </div>
              </button>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
}
